export const PERM = {
	HistoricoDeAcesso: {
		Visualizar: "94377c9612f5793c956350798ffe7ef8"
	},
	Permissao: {
		Cadastrar: "16df2b0d3fcd8c5bf371f9f978c010b0",
		Editar: "7d3ee19188e7b4111c51b5956fdcaeec",
		Visualizar: "f1efce3afcfdabafacf72ee6170a894e",
		Excluir: "47ac740994ff16a40a42a845b7b72203",
		Ativardesativar: "09f8441a968f7f2ba74cd0e85f967ce7"
	},
	Usuario: {
		Cadastrar: "67e62db9378e7d0d76547727c6930f98",
		Editar: "6995bf1fc84d7e0c604d44f1ef88b99e",
		Visualizar: "82b7a6fbd9040eb8d2dbbc7b70d52872",
		Excluir: "bd201296eca5edd5c2ba5b6645285deb",
		Ativardesativar: "a486b0d9ea06e8ddc5cc4204c36bfe70"
	},
	Dispositivo: {
		Cadastrar: "3caff9e6332e80b96a00ed8a5e9fa136",
		Editar: "8d830f5a1c9e2f02a61eb946f5bf5bf1",
		Visualizar: "1bd1810299c5f155ee424c0ad5a18b16",
		Excluir: "7d70f75496a251ff223b8fa1ca1cf2a8",
		Ativardesativar: "54e8ac6930b474ecce93126596b205ec",
		Revogar: "d4dd88e7c0ff395f30d6374457164b29"
	},
	ConfiguracoesDoSistema: {
		Visualizar: "d9b029d4e580a0910448c2534a200f25",
		Editar: "9423da8ddd804ca21e8da8b4955ead6c"
	},
	Logs: {
		VisualizarLogsDoSite: "caa33c549ae4e21a160be2a390b67c1b",
		VisualizarLogsDeDispositivos: "eb31750991511aef77ded9d2530f2547",
		VisualizarLogsDePessoalDeCampo: "333c27eae1203552b77d393fb6dab332"
	},
	Rota: {
		Cadastrar: "bb9ae58afe6dc37d59f930d70c62782d",
		Editar: "978bd2964c9e0b8745d6d5b02e4f56cb",
		Visualizar: "e9f54a86a5e7ec6db14530ed64eb3d9d",
		Excluir: "fe7bebe92a7bfc600e852ffe5f941c53",
		Ativardesativar: "5cdc5b97e03b8c2626ca589a2923e801"
	},
	Marca: {
		Cadastrar: "1c4df8d69d7f71cab365382cd65dc79d",
		Editar: "0a8a2336d9eaad6755f3e67d991155f1",
		Visualizar: "a87b34ef351f2a314867c4dbdce0b1b8",
		Excluir: "e5a577ba47dca4b66b4302fe571212fc",
		Ativardesativar: "72e5f15deccaaffe9723f11869984822"
	},
	Modelo: {
		Cadastrar: "e09de704534fbb2ddb75535828827508",
		Editar: "e46d014cff0dd7326127d78c4290900b",
		Visualizar: "073fabd7c22fdc200e2361fe47d346cc",
		Excluir: "9336aed1021faa11a81fe173afdda20d",
		Ativardesativar: "4e94a332f3b2f39b658f0fc9fa38ace0"
	},
	Cidade: {
		Cadastrar: "9703307aff531055f3c01146d419a944",
		Editar: "f84e9d561a112d867730480b3a2e9704",
		Visualizar: "192cfd0df7376c560b58bb46d75a3cab",
		Excluir: "5611fe9af6d89dffada4019b9f966689",
		Ativardesativar: "587e73fb970e34d872a4d28e12450dfa"
	},
	Regional: {
		Cadastrar: "6d92c966a8d02fc2e73791d4cbff6266",
		Editar: "3ca613f81ccf89392f33f13765cc6846",
		Visualizar: "a13540c32c155f48be38c8eb4e7e906b",
		Excluir: "3862d0f97bde50a125e02fe24966f7d7",
		Ativardesativar: "924f53afd6eb917bcba89a27c68a041c"
	},
	Contrato: {
		Cadastrar: "e453625daa7312861ef19f3c31ace0c3",
		Editar: "2bb45dd3374fb5fb2fc73e6401467aea",
		Visualizar: "108f10ff3cd13c42c72d03c3c8ed4865",
		Excluir: "b2c3fa962e96cc7abb8e04bd6690a29b",
		Ativardesativar: "74de2d8b87148cb18bd2ceffc9d35ebb"
	},
	Faixa: {
		Cadastrar: "38b46d136b46aaf511c645a14a6c7817",
		Editar: "2a341044408523952f9cb215a6fc195e",
		Visualizar: "13e69286e86b8acadd244aff97e400d5",
		Excluir: "c3ef09f651a3cc3e1e2d657b8cba545a",
		Ativardesativar: "8ab7cb7d94e51c51787190d4c34a89d0"
	},
	TipoDeCaptura: {
		Cadastrar: "cd61a8c5f2105b9d0056e42378b180ee",
		Editar: "2f488722076a0f7b481fc772b2372261",
		Visualizar: "a1a7439ccaa3a5becdf6be636d704f68",
		Excluir: "4e610d81b512c9f151b80b225c7b7094",
		Ativardesativar: "2dc4c689b2b1da4cdc527df89d7cf4e7"
	},
	Solicitacao: {
		Cadastrar: "ca01b96ce571efd59dbb0b6e81eac7fa",
		Editar: "690f58aa3c8230cc470e765d7e183420",
		Visualizar: "002a21b0ff28ac494247415e947cea96",
		Excluir: "b6fb980137dd43e1bb1dec30b8f19ad0",
		Ativardesativar: "bbc4fc5825a1868015b1307dda31fd4d"
	},
	MotivoAusencia: {
		Cadastrar: "07e9d8238fffce798d5a5b63c1df08d5",
		Editar: "ab92693455e739ab084ac429466b0e93",
		Visualizar: "160d1d3d9d3e5e3406ac884cd9591e8b",
		Excluir: "01a0daea4b47a28413e922ce58a498de",
		Ativardesativar: "4dafdc788db1a48728a267bba102f284"
	},
	Registro: {
		Editar: "22cd5d7acb2505205c1bd0197901bb75",
		Visualizar: "591ccdea1a0337d7dcb35b970c711fc5",
		Excluir: "12100b24d9aeccf395192688114e2557",
		Ativardesativar: "b31bfb895a0a81bf80611e5833b2b57b",
		Cadastrar: "33db22213a3f64aae4ff8e431403140d"
	},
	Programacao: {
		Gerar: "bf198fbcba5bb36a102f284da1215f4d",
		Editar: "cea6f96baff8e7f12a2c32ffb4623dae",
		Visualizar: "79596bc3985f9443714e428e6ce7e37b",
		Ativardesativar: "0b2f73b33403880acfd0b9e44db58939",
		Excluir: "7e3a33ad81abb86d49a9da54663de036"
	},
	ContratoZip: {
		Gerar: "aa0b89094770b5e4c9140633e7bea14c",
		Visualizar: "3850094797b3577e645ef2c2d10debf9",
		Editar: "75a40d79a607d73a82fd6b4939867aba",
		Excluir: "3741d48c0a94f66a3264171e469e61f5"
	},
	Relatorios: {
		Visualizar: "02c30c71b7ff85844630ef234a8c671b"
	}
}
export const PERM_INDEX = { 
	'94377c9612f5793c956350798ffe7ef8': 'HISTÓRICO DE ACESSO(VISUALIZAR)',
	'16df2b0d3fcd8c5bf371f9f978c010b0': 'PERMISSÃO(CADASTRAR)',
	'7d3ee19188e7b4111c51b5956fdcaeec': 'PERMISSÃO(EDITAR)',
	'f1efce3afcfdabafacf72ee6170a894e': 'PERMISSÃO(VISUALIZAR)',
	'47ac740994ff16a40a42a845b7b72203': 'PERMISSÃO(EXCLUIR)',
	'09f8441a968f7f2ba74cd0e85f967ce7': 'PERMISSÃO(ATIVAR/DESATIVAR)',
	'67e62db9378e7d0d76547727c6930f98': 'USUÁRIO(CADASTRAR)',
	'6995bf1fc84d7e0c604d44f1ef88b99e': 'USUÁRIO(EDITAR)',
	'82b7a6fbd9040eb8d2dbbc7b70d52872': 'USUÁRIO(VISUALIZAR)',
	'bd201296eca5edd5c2ba5b6645285deb': 'USUÁRIO(EXCLUIR)',
	'a486b0d9ea06e8ddc5cc4204c36bfe70': 'USUÁRIO(ATIVAR/DESATIVAR)',
	'3caff9e6332e80b96a00ed8a5e9fa136': 'DISPOSITIVO(CADASTRAR)',
	'8d830f5a1c9e2f02a61eb946f5bf5bf1': 'DISPOSITIVO(EDITAR)',
	'1bd1810299c5f155ee424c0ad5a18b16': 'DISPOSITIVO(VISUALIZAR)',
	'7d70f75496a251ff223b8fa1ca1cf2a8': 'DISPOSITIVO(EXCLUIR)',
	'54e8ac6930b474ecce93126596b205ec': 'DISPOSITIVO(ATIVAR/DESATIVAR)',
	'd4dd88e7c0ff395f30d6374457164b29': 'DISPOSITIVO(REVOGAR)',
	'd9b029d4e580a0910448c2534a200f25': 'CONFIGURAÇÕES DO SISTEMA(VISUALIZAR)',
	'9423da8ddd804ca21e8da8b4955ead6c': 'CONFIGURAÇÕES DO SISTEMA(EDITAR)',
	'caa33c549ae4e21a160be2a390b67c1b': 'LOGS(VISUALIZAR LOGS DO SITE)',
	'eb31750991511aef77ded9d2530f2547': 'LOGS(VISUALIZAR LOGS DE DISPOSITIVOS)',
	'333c27eae1203552b77d393fb6dab332': 'LOGS(VISUALIZAR LOGS DE PESSOAL DE CAMPO)',
	'bb9ae58afe6dc37d59f930d70c62782d': 'ROTA(CADASTRAR)',
	'978bd2964c9e0b8745d6d5b02e4f56cb': 'ROTA(EDITAR)',
	'e9f54a86a5e7ec6db14530ed64eb3d9d': 'ROTA(VISUALIZAR)',
	'fe7bebe92a7bfc600e852ffe5f941c53': 'ROTA(EXCLUIR)',
	'5cdc5b97e03b8c2626ca589a2923e801': 'ROTA(ATIVAR/DESATIVAR)',
	'1c4df8d69d7f71cab365382cd65dc79d': 'MARCA(CADASTRAR)',
	'0a8a2336d9eaad6755f3e67d991155f1': 'MARCA(EDITAR)',
	'a87b34ef351f2a314867c4dbdce0b1b8': 'MARCA(VISUALIZAR)',
	'e5a577ba47dca4b66b4302fe571212fc': 'MARCA(EXCLUIR)',
	'72e5f15deccaaffe9723f11869984822': 'MARCA(ATIVAR/DESATIVAR)',
	'e09de704534fbb2ddb75535828827508': 'MODELO(CADASTRAR)',
	'e46d014cff0dd7326127d78c4290900b': 'MODELO(EDITAR)',
	'073fabd7c22fdc200e2361fe47d346cc': 'MODELO(VISUALIZAR)',
	'9336aed1021faa11a81fe173afdda20d': 'MODELO(EXCLUIR)',
	'4e94a332f3b2f39b658f0fc9fa38ace0': 'MODELO(ATIVAR/DESATIVAR)',
	'9703307aff531055f3c01146d419a944': 'CIDADE(CADASTRAR)',
	'f84e9d561a112d867730480b3a2e9704': 'CIDADE(EDITAR)',
	'192cfd0df7376c560b58bb46d75a3cab': 'CIDADE(VISUALIZAR)',
	'5611fe9af6d89dffada4019b9f966689': 'CIDADE(EXCLUIR)',
	'587e73fb970e34d872a4d28e12450dfa': 'CIDADE(ATIVAR/DESATIVAR)',
	'6d92c966a8d02fc2e73791d4cbff6266': 'REGIONAL(CADASTRAR)',
	'3ca613f81ccf89392f33f13765cc6846': 'REGIONAL(EDITAR)',
	'a13540c32c155f48be38c8eb4e7e906b': 'REGIONAL(VISUALIZAR)',
	'3862d0f97bde50a125e02fe24966f7d7': 'REGIONAL(EXCLUIR)',
	'924f53afd6eb917bcba89a27c68a041c': 'REGIONAL(ATIVAR/DESATIVAR)',
	'e453625daa7312861ef19f3c31ace0c3': 'CONTRATO(CADASTRAR)',
	'2bb45dd3374fb5fb2fc73e6401467aea': 'CONTRATO(EDITAR)',
	'108f10ff3cd13c42c72d03c3c8ed4865': 'CONTRATO(VISUALIZAR)',
	'b2c3fa962e96cc7abb8e04bd6690a29b': 'CONTRATO(EXCLUIR)',
	'74de2d8b87148cb18bd2ceffc9d35ebb': 'CONTRATO(ATIVAR/DESATIVAR)',
	'38b46d136b46aaf511c645a14a6c7817': 'FAIXA(CADASTRAR)',
	'2a341044408523952f9cb215a6fc195e': 'FAIXA(EDITAR)',
	'13e69286e86b8acadd244aff97e400d5': 'FAIXA(VISUALIZAR)',
	'c3ef09f651a3cc3e1e2d657b8cba545a': 'FAIXA(EXCLUIR)',
	'8ab7cb7d94e51c51787190d4c34a89d0': 'FAIXA(ATIVAR/DESATIVAR)',
	'cd61a8c5f2105b9d0056e42378b180ee': 'TIPO DE CAPTURA(CADASTRAR)',
	'2f488722076a0f7b481fc772b2372261': 'TIPO DE CAPTURA(EDITAR)',
	'a1a7439ccaa3a5becdf6be636d704f68': 'TIPO DE CAPTURA(VISUALIZAR)',
	'4e610d81b512c9f151b80b225c7b7094': 'TIPO DE CAPTURA(EXCLUIR)',
	'2dc4c689b2b1da4cdc527df89d7cf4e7': 'TIPO DE CAPTURA(ATIVAR/DESATIVAR)',
	'ca01b96ce571efd59dbb0b6e81eac7fa': 'SOLICITAÇÃO(CADASTRAR)',
	'690f58aa3c8230cc470e765d7e183420': 'SOLICITAÇÃO(EDITAR)',
	'002a21b0ff28ac494247415e947cea96': 'SOLICITAÇÃO(VISUALIZAR)',
	'b6fb980137dd43e1bb1dec30b8f19ad0': 'SOLICITAÇÃO(EXCLUIR)',
	'bbc4fc5825a1868015b1307dda31fd4d': 'SOLICITAÇÃO(ATIVAR/DESATIVAR)',
	'07e9d8238fffce798d5a5b63c1df08d5': 'MOTIVO AUSÊNCIA(CADASTRAR)',
	'ab92693455e739ab084ac429466b0e93': 'MOTIVO AUSÊNCIA(EDITAR)',
	'160d1d3d9d3e5e3406ac884cd9591e8b': 'MOTIVO AUSÊNCIA(VISUALIZAR)',
	'01a0daea4b47a28413e922ce58a498de': 'MOTIVO AUSÊNCIA(EXCLUIR)',
	'4dafdc788db1a48728a267bba102f284': 'MOTIVO AUSÊNCIA(ATIVAR/DESATIVAR)',
	'22cd5d7acb2505205c1bd0197901bb75': 'REGISTRO(EDITAR)',
	'591ccdea1a0337d7dcb35b970c711fc5': 'REGISTRO(VISUALIZAR)',
	'12100b24d9aeccf395192688114e2557': 'REGISTRO(EXCLUIR)',
	'b31bfb895a0a81bf80611e5833b2b57b': 'REGISTRO(ATIVAR/DESATIVAR)',
	'33db22213a3f64aae4ff8e431403140d': 'REGISTRO(CADASTRAR)',
	'bf198fbcba5bb36a102f284da1215f4d': 'PROGRAMAÇÃO(GERAR)',
	'cea6f96baff8e7f12a2c32ffb4623dae': 'PROGRAMAÇÃO(EDITAR)',
	'79596bc3985f9443714e428e6ce7e37b': 'PROGRAMAÇÃO(VISUALIZAR)',
	'0b2f73b33403880acfd0b9e44db58939': 'PROGRAMAÇÃO(ATIVAR/DESATIVAR)',
	'7e3a33ad81abb86d49a9da54663de036': 'PROGRAMAÇÃO(EXCLUIR)',
	'aa0b89094770b5e4c9140633e7bea14c': 'CONTRATO ZIP(GERAR)',
	'3850094797b3577e645ef2c2d10debf9': 'CONTRATO ZIP(VISUALIZAR)',
	'75a40d79a607d73a82fd6b4939867aba': 'CONTRATO ZIP(EDITAR)',
	'3741d48c0a94f66a3264171e469e61f5': 'CONTRATO ZIP(EXCLUIR)',
	'02c30c71b7ff85844630ef234a8c671b': 'RELATÓRIOS(VISUALIZAR)' 
}